module.exports = __webpack_public_path__ + "img/smartphone-call.ff09e6f9.svg";